import { render, staticRenderFns } from "./chatwootButton.vue?vue&type=template&id=24105ff6&"
import script from "./chatwootButton.vue?vue&type=script&lang=ts&"
export * from "./chatwootButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports